import { IContainer } from './interface';
import bindApi from './api/private/bind';
import bindController from './controller/private/bind';
import bindDB from './db/private/bind';
import bindJobs from './jobs/private/bind';
import bindModel from './model/private/bind';
import bindSession from './session/private/bind';
import { container as privateContainer } from './private';

export function bindAll(container: IContainer) {
    bindModel.bind(container);

    /* private */
    bindApi.bind(container);
    bindDB.bind(container);
    bindController.bind(container);

    bindJobs.bind(container);
    bindSession.bind(container);
}

function _publicBind(container: IContainer) {
    bindAll(container);

    /* private */
    bindApi.unbind(container);
    bindDB.unbind(container);
    bindController.unbind(container);
}

function setup(containerGlobal: IContainer) {
    const prvContainer = privateContainer();
    prvContainer.importBindings(containerGlobal);
    bindAll(prvContainer);

    _publicBind(containerGlobal);
}

export default setup;
